export default __webpack_public_path__ + "1b9e5bf8bca13f2332909bea718bf89d.png";